import * as React from 'react'

export const BellIcon = React.memo<JSX.IntrinsicElements['svg']>((props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C13.1046 2 14 2.89543 14 4V4.34141C16.3304 5.16509 18 7.38756 18 10V16H19C19.5523 16 20 16.4477 20 17C20 17.5523 19.5523 18 19 18H5C4.44772 18 4 17.5523 4 17C4 16.4477 4.44772 16 5 16H6V10C6 7.38757 7.66961 5.16509 10 4.34141V4C10 2.89543 10.8954 2 12 2Z"
        fill="white"
      />
      <path
        d="M9.04141 19.4996C9.27929 20.9187 10.5134 22 12 22C13.4866 22 14.7207 20.9187 14.9586 19.4996H9.04141Z"
        fill="white"
      />
    </svg>
  )
})

BellIcon.displayName = 'BellIcon'
